import React from "react";
import _ from "lodash";
import generateContentDataObject from "../../../../helpers/editor/generateContentDataObject";
import DebouncedInput from "../../../DebouncedInput";
import ContentInputsTypesEnum from "../../../../enums/ContentInputsTypesEnum";
import { GraphicsOptions } from "../../component_graphics/data/componentGraphicsData";
import { useCurrentInputData } from "../useCurrentInputData";

interface Props {
  saveContentInStore: any;
  contentType: ContentInputsTypesEnum;
  currentInputData: any;
  keyProp: number;
  toggleNewEditionsDetected: (value: boolean) => void;
  item: any;
}

const GalleryVideoInput = (props: Props): JSX.Element => {
  const {
    saveContentInStore,
    contentType,
    currentInputData,
    keyProp,
    toggleNewEditionsDetected,
    item,
  } = props;
  const currentInputDataRef = useCurrentInputData(currentInputData);

  const generator = new generateContentDataObject();

  const handleOnChange = (value: string) => {
    saveContentInStore(
      generator.changeGalleryVideoUrl(
        { [contentType]: currentInputDataRef.current },
        value,
        keyProp,
        0
      )
    );
    toggleNewEditionsDetected(true);
  };

  return (
    <div className="content-input__input">
      <DebouncedInput
        placeholder="https://www.youtube.com/watch?v=7wtfhZwyrcc"
        debounceDelay={2000}
        onChange={handleOnChange}
        defaultValue={_.get(item, [
          "contentGraphic",
          0,
          GraphicsOptions.video,
          "youtube",
          "url",
        ])}
        id={contentType}
      />
    </div>
  );
};

export default GalleryVideoInput;
